export default {
  brand: {
    name: "Basetao Sheet",
    tagline: "El centro de recursos Basetao",
  },
  nav: {
    spreadsheet: "Hoja de cálculo",
    reviews: "Reseñas",
    shipping: "Envío",
    coupons: "Cupones",
    warehouse: "Almacén",
    qc: "QC",
    guides: "Guías",
    safety: "Seguridad",
    cta: "Explorar la hoja",
    home: "Inicio",
    shoppingGuide: "Guía de compra",
  },
  lang: {
    label: "Idioma",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  categories: {
    title: "Comprar por categoría",
    dropdownLabel: "Explorar categorías",
    browseCta: "Ver todas las categorías",
    shoes: "Zapatos",
    hoodies: "Sudaderas / Jerséis",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones / Shorts",
    headwear: "Sombrerería",
    sets: "Conjuntos",
    underwear: "Ropa interior / Calzoncillos",
    jersey: "Camiseta deportiva",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otros artículos",
  },
  hero: {
    eyebrow: "EL CENTRO DE RECURSOS BASETAO",
    title: "Basetao Spreadsheet — Encuentra productos, vendedores, QC y envío más rápido",
    subtitle:
      "Explora el Basetao Spreadsheet: recursos de productos organizados, guías de vendedores, información de QC, guías de envío, consejos de almacén, reseñas y recursos de compra prácticos — todo en un solo lugar.",
    primaryCta: "Basetao Spreadsheet",
    secondaryCta: "Comprar ahora",
    trust: "Recurso independiente • Actualizado regularmente • Apto para principiantes",
  },
  what: {
    title: "¿Qué es un Basetao Spreadsheet?",
    subtitle:
      "Un Basetao Spreadsheet es una forma estructurada de organizar y descubrir información de productos, vendedores, enlaces y recursos de compra. Hace que la investigación de productos sea más rápida y fácil de navegar.",
    card1Title: "Encontrar productos",
    card1Desc: "Descubre recursos de productos organizados.",
    card2Title: "Investigar vendedores",
    card2Desc: "Revisa la información del vendedor de un vistazo.",
    card3Title: "Comprobar QC",
    card3Desc: "Comprende los detalles del control de calidad.",
    card4Title: "Comparar envío",
    card4Desc: "Comprende claramente las variables de envío.",
    cta: "Explorar el Basetao Spreadsheet",
  },
  popular: {
    title: "Búsquedas populares",
    subtitle: "Los temas que más buscan los compradores de Basetao.",
    items: [
      "Basetao Spreadsheet",
      "Reseña Basetao",
      "Coste de envío Basetao",
      "Cupón Basetao",
      "Código de descuento Basetao",
      "Almacén Basetao",
      "¿Es legítimo Basetao?",
      "QC Basetao",
    ],
  },
  why: {
    title: "¿Por qué usar este sitio?",
    subtitle: "Creado para que tu investigación de Basetao sea más clara y rápida.",
    items: [
      { title: "Organizado", desc: "Todo estructurado en un lugar claro." },
      { title: "Práctico", desc: "Enfocado en decisiones de compra reales." },
      { title: "Transparente", desc: "Explicamos límites e incertidumbres abiertamente." },
      { title: "Multilingüe", desc: "Disponible en cinco idiomas." },
    ],
  },
  how: {
    title: "Cómo funciona",
    subtitle: "Un flujo de investigación simple, del descubrimiento al pago.",
    steps: [
      { title: "Encontrar", desc: "Explora recursos de productos y vendedores." },
      { title: "Investigar", desc: "Revisa anuncios, vendedores y enlaces." },
      { title: "Comparar", desc: "Pesa QC, envío y precio." },
      { title: "Verificar", desc: "Revisa notas de seguridad y señales de alerta." },
      { title: "Continuar", desc: "Ve al sitio principal para comprar." },
    ],
  },
  safety: {
    title: "Nota de seguridad importante",
    text:
      "Los anuncios, vendedores, costes de envío y promociones pueden cambiar. Las guías y hojas de cálculo organizan la información, pero no pueden garantizar la calidad del producto, la fiabilidad del vendedor ni los resultados de entrega.",
    links: [
      "Seguridad del vendedor",
      "Guía de QC",
      "Riesgo de envío",
      "Seguridad de pago",
      "¿Es legítimo Basetao?",
    ],
  },
  faq: {
    title: "Preguntas frecuentes",
    items: [
      {
        q: "¿Qué es un Basetao Spreadsheet?",
        a: "Es un documento estructurado que organiza productos, vendedores, precios, fotos QC y detalles de envío en un solo lugar, facilitando la investigación.",
      },
      {
        q: "¿Cómo funciona un Basetao Spreadsheet?",
        a: "Agrupa información útil en columnas y categorías para encontrar, comparar y seguir artículos más rápido que revisando mensajes dispersos.",
      },
      {
        q: "¿Es legítimo Basetao?",
        a: "Basetao es un agente de compras usado desde hace tiempo por muchos compradores internacionales. Este sitio es independiente: verifica siempre tú mismo los vendedores y pedidos.",
      },
      {
        q: "¿Cuánto cuesta el envío de Basetao?",
        a: "El coste depende del peso, dimensiones, destino, método y seguro. Consulta la guía de envío del sitio principal para las tarifas actuales.",
      },
      {
        q: "¿Dónde encuentro cupones de Basetao?",
        a: "Las promociones cambian a menudo. Busca ofertas verificadas y actuales en lugar de códigos caducados de otros sitios.",
      },
    ],
  },
  finalCta: {
    title: "¿Listo para explorar el Basetao Spreadsheet?",
    subtitle: "Explora productos, vendedores y recursos organizados en el sitio principal.",
    button: "Explorar el Basetao Spreadsheet",
  },
  guides: {
    title: "Guías y recursos Basetao",
    subtitle:
      "Artículos clave que cubren la hoja de cálculo, reseñas, envío, cupones, almacén y seguridad.",
    readMore: "Leer artículo",
  },
  footer: {
    description:
      "Un recurso de información independiente sobre el Basetao Spreadsheet. No afiliado ni respaldado por Basetao.",
    resources: "Recursos",
    about: "Acerca de",
    contact: "Contacto",
    privacy: "Privacidad",
    terms: "Términos",
    disclaimer: "Aviso legal",
    cookie: "Política de cookies",
    languages: "Idiomas",
    copyright: "© 2026 Basetao Sheet. Todos los derechos reservados.",
  },
  article: {
    breadcrumb: "Inicio › Guías",
    h1: "Basetao Spreadsheet: la guía completa de productos, vendedores, QC y envío",
    updated: "Última actualización: 19 de agosto de 2026",
    quickAnswerLabel: "Respuesta rápida",
    quickAnswer:
      "Un Basetao Spreadsheet es un documento estructurado y compartido que organiza productos, vendedores, precios, fotos QC y detalles de envío en un solo lugar. Te ayuda a encontrar artículos más rápido, comparar vendedores y seguir pedidos — mucho más fácil que revisar mensajes dispersos.",
    tocTitle: "Tabla de contenidos",
    sections: [
      {
        title: "¿Qué es un Basetao Spreadsheet?",
        body: [
          "Un Basetao Spreadsheet es, en esencia, una tabla compartida que reúne todo lo que un comprador necesita para investigar una compra. En lugar de buscar en el historial de chat, álbumes de vendedores o favoritos, encuentras nombres de productos, imágenes, detalles del vendedor, precios, estado QC y notas de envío en columnas claras.",
          "Esta organización es especialmente útil cuando comparas muchos artículos a la vez. La hoja actúa como una única fuente que puedes escanear rápidamente, lo que ahorra tiempo y reduce el riesgo de confundir productos similares de distintos vendedores.",
        ],
      },
      {
        title: "Por qué los compradores usan un Basetao Spreadsheet",
        body: [
          "La razón principal es la velocidad. Cuando la investigación está estructurada, pasas menos tiempo buscando y más decidiendo. Una hoja también deja constancia de lo que encontraste, pediste y lo que aún falta por comprobar.",
          "Para pedidos grandes o compras repetidas, una hoja te ayuda a ser constante. Puedes seguir a vendedores de confianza, anotar qué artículos pasaron el control de calidad y recordar opciones de envío que funcionaron bien antes.",
        ],
      },
      {
        title: "Cómo se organiza un Basetao Spreadsheet",
        body: [
          "Una hoja típica agrupa la información en unas pocas columnas clave: nombre del producto, imagen, categoría, vendedor, precio, estado QC y un enlace al artículo. Algunas también incluyen peso de envío, notas de almacén y observaciones personales.",
          "Las categorías suelen reflejar la estructura de la tienda — zapatos, sudaderas, camisetas, chaquetas, pantalones, sombrerería, conjuntos, ropa interior, camisetas deportivas, accesorios, bolsos, cinturones, perfumes y otros artículos. Así puedes ir directo a la sección que te interesa.",
        ],
      },
      {
        title: "Cómo encontrar productos con un Basetao Spreadsheet",
        body: [
          "Empieza por la categoría que te interesa y escanea los nombres e imágenes en busca de artículos que encajen. Usa las columnas de vendedor y precio para acotar tus opciones.",
          "En cuanto veas un artículo prometedor, abre su enlace en el sitio principal para ver los detalles completos, la disponibilidad y las ofertas actuales. La hoja es el punto de partida — el anuncio en sí es donde confirmas los detalles.",
        ],
      },
      {
        title: "Cómo investigar a los vendedores",
        body: [
          "Investigar al vendedor importa porque la calidad y la fiabilidad varían. Fíjate en si un vendedor aparece de forma constante, cómo se describen sus productos y si las notas QC pasadas marcan problemas recurrentes.",
          "Trata la información del vendedor como una primera señal, no una garantía. Las condiciones cambian: vuelve a comprobar cada vendedor en cada pedido, sobre todo en artículos de mayor valor.",
        ],
      },
      {
        title: "Entender las fotos QC",
        body: [
          "Las fotos QC (control de calidad) son una de las partes más valiosas del proceso de compra. Muestran el artículo real antes del envío, para detectar pronto problemas de talla, color o defectos.",
          "Al revisar fotos QC, compáralas con el anuncio original. Fíjate en costuras, logotipos, colores y medidas. Si algo parece raro, pregunta antes de que se envíe el artículo.",
        ],
      },
      {
        title: "Costes y opciones de envío",
        body: [
          "El coste de envío no es una cifra fija — depende del peso del paquete, dimensiones, país de destino, método elegido y seguro. Los paquetes más pesados o voluminosos suelen costar más.",
          "Las distintas líneas de envío equilibran rapidez y precio. Algunas son más rápidas pero más caras, otras más baratas pero más lentas. La elección correcta depende de cuán rápido necesites el paquete y cuánto quieras gastar.",
        ],
      },
      {
        title: "Errores comunes que evitar",
        body: [
          "Un error frecuente es pedir antes de revisar las fotos QC, lo que dificulta solucionar problemas. Otro es ignorar el peso al planificar el envío, lo que puede dar una factura inesperadamente alta.",
          "También es fácil confundir artículos similares de distintos vendedores. Usar la hoja para anotar qué artículo viene de qué vendedor evita confusiones y mantiene los pedidos organizados.",
        ],
      },
      {
        title: "Seguridad y señales de alerta",
        body: [
          "Mantén una precaución saludable. Desconfía de vendedores sin historial, precios demasiado buenos para ser ciertos o anuncios que reutilizan fotos sin relación. Los pequeños depósitos o solicitudes de pago inusuales también pueden ser señales de alerta.",
          "Este sitio es un recurso independiente: verifica siempre la información tú mismo. Ninguna guía puede garantizar la calidad del producto, la fiabilidad del vendedor ni los resultados de entrega. Usa estos recursos como un punto de partida útil, no como un sustituto de tu propio criterio.",
        ],
      },
    ],
    tableTitle: "Hoja de cálculo vs. notas dispersas",
    tableHeaders: ["Función", "Basetao Spreadsheet", "Notas manuales"],
    tableRows: [
      ["Descubrimiento de productos", "Organizado y filtrable", "Difícil de buscar"],
      ["Investigación de vendedores", "Columnas estructuradas", "Mensajes dispersos"],
      ["Seguimiento QC", "Campos QC dedicados", "Mezclado con el chat"],
      ["Planificación de envío", "Claro de un vistazo", "Requiere buscar"],
      ["Ideal para", "Investigadores serios", "Navegación ocasional"],
    ],
    faqTitle: "Preguntas frecuentes",
    faqs: [
      {
        q: "¿Es gratuito un Basetao Spreadsheet?",
        a: "Las hojas de cálculo suelen ser recursos compartidos. Consulta el sitio principal para la versión actual y los detalles de acceso.",
      },
      {
        q: "¿Con qué frecuencia se actualiza la hoja?",
        a: "Las actualizaciones varían. Anuncios, vendedores y precios cambian: trata la información como una instantánea y confirma los detalles en el sitio principal antes de pedir.",
      },
      {
        q: "¿Puedo usar la hoja en el móvil?",
        a: "La mayoría de documentos estructurados funcionan en escritorio y móvil. Para comparar muchas columnas, una pantalla más grande suele ser más cómoda.",
      },
      {
        q: "¿La hoja garantiza la calidad del producto?",
        a: "No. Organiza la información, pero no puede garantizar calidad, fiabilidad del vendedor ni resultados de entrega. Revisa siempre las fotos QC y haz tus propias comprobaciones.",
      },
    ],
    conclusion:
      "Un Basetao Spreadsheet es una herramienta práctica para cualquiera que quiera investigar productos, vendedores, QC y envío de forma más eficiente. Reúne información dispersa en una vista clara, para tomar mejores decisiones y perder menos tiempo buscando. Recuerda que los detalles cambian: usa la hoja como guía y confirma siempre la información más reciente en el sitio principal antes de comprar.",
    relatedTitle: "Recursos relacionados",
    backHome: "Volver al inicio",
    ctaLabel: "Explorar el Basetao Spreadsheet",
    conclusionTitle: "Conclusión",
    readGuide: "Leer la guía",
    toc: [
      "¿Qué es un Basetao Spreadsheet?",
      "Por qué los compradores usan un Basetao Spreadsheet",
      "Cómo se organiza un Basetao Spreadsheet",
      "Cómo encontrar productos",
      "Cómo investigar a los vendedores",
      "Entender las fotos QC",
      "Costes y opciones de envío",
      "Errores comunes que evitar",
      "Seguridad y señales de alerta",
    ],
  },
};